import { AppConfig } from './config.model';
import { EnvironmentProviders, Provider } from '@angular/core';
import { MAIN_APP_CONFIG } from './config.constants';

export const provideFrontendConfig = (config: AppConfig): Array<Provider | EnvironmentProviders> => {
  // Base providers
  const providers: Array<Provider | EnvironmentProviders> = [
    {
      provide: MAIN_APP_CONFIG,
      useValue: config ?? {},
    },
  ];
  return providers;
};
